import React from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import styles from "./RootLayout.module.scss";
import CookieBanner from "../components/cookie-banner/CookieBanner";
import Footer from "../components/footer/Footer";
import CookiePreferenceModal from "../components/cookie-preference-modal/CookiePreferenceModal";
import TermsOfUse from "../components/ToU/ToU"; // Updated path to match your naming
import { useAppContext } from "../context/AppContext";

const RootLayout = ({ children }) => {
	const { cookiePreferenceSet, tenantGroup } = useAppContext();
	
	return (
		<div className={styles.rootWrapper}>
			<div className={styles.mainContentWrapper}>
				<Router>
					<div className={styles.routesWrapper}>
						<Routes>{children}</Routes>
					</div>
				</Router>
			</div>

			{tenantGroup == "virtualcare" && (
				<>
					<footer className={styles.footerWrapper}>
						<Footer />
					</footer>
					<CookiePreferenceModal />
					{!cookiePreferenceSet && <CookieBanner />}
					<TermsOfUse />
				</>
			)}
		</div>
	);
};

export default RootLayout;
